import AutoFixHighOutlined from '@mui/icons-material/AutoFixHighOutlined';
import BoltOutlined from '@mui/icons-material/BoltOutlined';
import ChatBubbleOutlineOutlined from '@mui/icons-material/ChatBubbleOutlineOutlined';
import ContentPasteOutlined from '@mui/icons-material/ContentPasteOutlined';
import DiamondOutlined from '@mui/icons-material/DiamondOutlined';
import DocumentScannerOutlined from '@mui/icons-material/DocumentScannerOutlined';
import EmojiEventsOutlined from '@mui/icons-material/EmojiEventsOutlined';
import LocalFireDepartmentOutlined from '@mui/icons-material/LocalFireDepartmentOutlined';
import RocketLaunchOutlined from '@mui/icons-material/RocketLaunchOutlined';
import SpeedOutlined from '@mui/icons-material/SpeedOutlined';
import StraightenOutlined from '@mui/icons-material/StraightenOutlined';
import TrendingDownOutlined from '@mui/icons-material/TrendingDownOutlined';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ComponentType } from 'react';

const ICON_BY_NAME: Record<string, ComponentType<SvgIconProps>> = {
  flame: LocalFireDepartmentOutlined,
  trophy: EmojiEventsOutlined,
  'trending-down': TrendingDownOutlined,
  wand: AutoFixHighOutlined,
  'message-circle': ChatBubbleOutlineOutlined,
  scan: DocumentScannerOutlined,
  ruler: StraightenOutlined,
  gauge: SpeedOutlined,
  rocket: RocketLaunchOutlined,
  bolt: BoltOutlined,
  clipboard: ContentPasteOutlined,
  gem: DiamondOutlined,
};

export function iconFor(
  name: string,
  fallback: ComponentType<SvgIconProps>,
): ComponentType<SvgIconProps> {
  return ICON_BY_NAME[name] ?? fallback;
}
